// ======================================================================
// File: src/modules/ppe/pages/procurement/purchase-return/list/purchaseReturnColumns.js
// Module: PPE → Procurement → Purchase Return
//
// Purpose:
// - Column definitions for Purchase Return list table
// - Centralized configuration similar to grnColumns.js
// ======================================================================

import React from "react";
import { formatDate } from "../../../../../../utils/formatUtils";

const purchaseReturnColumns = [
  {
    key: "return_no",
    title: "Return No",
  },

  {
    key: "return_date",
    title: "Date",
    render: (row) => formatDate(row.return_date),
  },

  {
    key: "vendor_name",
    title: "Vendor",
    render: (row) =>
      row.vendor_name || row.vendor_id || "-",
  },

  {
    key: "po_no",
    title: "PO No",
    render: (row) =>
      row.po_no || row.po_id || "-",
  },

  {
    key: "grn_no",
    title: "GRN No",
    render: (row) =>
      row.grn_no || row.grn_id || "-",
  },

  {
    key: "return_type",
    title: "Return Type",
    render: (row) =>
      row.return_type || "-",
  },

  {
    key: "status",
    title: "Status",
    render: (row) => {

      let color = "#6b7280";

      //switch (row.status) {
      switch (row.status_code) {  

        case "DRAFT":
          color = "#6b7280";
          break;

        case "PENDING_APPROVAL":
          color = "#0284c7";
          break;

        case "APPROVED":
          color = "#16a34a";
          break;

        case "POSTED":
          color = "#7c3aed";
          break;

        case "CANCELLED":
          color = "#dc2626";
          break;

        default:
          color = "#6b7280";
      }

      return (
        <span
          style={{
            padding: "4px 10px",
            borderRadius: 12,
            fontSize: 12,
            fontWeight: 500,
            background: "#f3f4f6",
            color: color,
          }}
        >
          {row.status_name || row.status_code || "-"}
        </span>
      );
    },
  },

  {
    key: "actions",
    title: "Actions",
    render: (row, { navigate }) => {
      return (
        <div style={{ display: "flex", gap: 8 }}>

          <span
            style={{
              color: "#2563eb",
              cursor: "pointer",
            }}
            onClick={() =>
              navigate(
                `/ppe/procurement/purchase-return/${row.id}`
              )
            }
          >
            View
          </span>

        </div>
      );
    },
  },
];

export default purchaseReturnColumns;